import { createSlice } from '@reduxjs/toolkit';

const initialState={
    user:null
}
export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {

    setLoggedInUser: (state, action) => {
      state.user = action.payload;
    },
    setLogoutUser: (state,action)=>{
      state.user=null
    }
  },
});

export const {  setLoggedInUser,setLogoutUser } = userSlice.actions;

export default userSlice.reducer;
